import {useTranslation} from "react-i18next";
import Page from "../../common/page/Page";
import PersonSearchPanel from "./PersonSearchPanel";
import {PersonTranslKey} from "./PersonTranslKey";
import {useState} from "react";
import {PersonDto} from "../../client/person/PersonApiClient";
import {DetailActionButton} from "../../common/button/CommonActionButtons";
import PersonDetailPanel from "./detail/PersonDetailPanel";

export function PersonPage() {
    const [selectedPerson, setSelectedPerson] = useState<PersonDto>();
    const [actionButtonGridReloadCount, setActionButtonGridReloadCount] = useState<number>(0);
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const {t} = useTranslation();

    const triggerPersonGridReload = (): void => {
        setActionButtonGridReloadCount(prev => prev + 1);
    };


    function onDetailDialogClose() {
        setDetailDialogOpen(false)
    }

    function onPersonSelected(person?: PersonDto) {
        if (person?.id !== selectedPerson?.id) {
            setSelectedPerson(person);
        }
    }

    function showDetailDialog() {
        setDetailDialogOpen(true);
    }

    const actions: React.ReactNode = (
        <>
            <DetailActionButton onClick={() => showDetailDialog()}
                                disabled={!selectedPerson} />
        </>
    );

    return (
        <Page title={t(PersonTranslKey.PERSON_OVERVIEW)}>
            <PersonSearchPanel actions={actions}
                               actionButtonGridReloadCounter={actionButtonGridReloadCount}
                               onSelectedPerson={onPersonSelected}
                               onPersonDoubleClick={showDetailDialog} />

            {selectedPerson && detailDialogOpen &&
                <PersonDetailPanel personId={selectedPerson.id}
                                   reloadPersonGrid={triggerPersonGridReload}
                                   open={detailDialogOpen}
                                   onClose={onDetailDialogClose} />
            }
        </Page>
    );
}
